module.exports = __webpack_public_path__ + "media/images/emoticons/baseball-f883eb5e6bb0c99f24a61ceddc9c8e1e.gif";